import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export { default as Alert } from './Alert.vue'
export { default as AlertAction } from './AlertAction.vue'
export { default as AlertDescription } from './AlertDescription.vue'
export { default as AlertTitle } from './AlertTitle.vue'

export const alertVariants = cva(
  'group/alert relative grid w-full gap-0.5 rounded-lg border px-4 py-3 text-left text-sm has-data-[slot=alert-action]:relative has-data-[slot=alert-action]:pr-18 has-[>svg]:grid-cols-[auto_1fr] has-[>svg]:gap-x-2.5 *:[svg]:row-span-2 *:[svg]:translate-y-0.5 *:[svg]:text-current *:[svg:not([class*=size-])]:size-4',
  {
    variants: {
      variant: {
        default: 'border-border bg-muted/40 text-foreground *:[svg]:text-muted-foreground',
        destructive:
          'border-destructive/25 bg-destructive/8 text-foreground *:data-[slot=alert-title]:text-destructive *:[svg]:text-destructive',
        warning:
          'border-warning/30 bg-warning/10 text-foreground *:data-[slot=alert-title]:text-warning *:[svg]:text-warning',
        info: 'border-info/25 bg-info/8 text-foreground *:data-[slot=alert-title]:text-info *:[svg]:text-info',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export type AlertVariants = VariantProps<typeof alertVariants>
